export interface ReviewInput {
  id?: string;
  product_variant_id: string;
  order_id:string;
  rating: number;
  title: string;
  message: string;
  gallery: string[];
}

export interface ReviewUpdateInput {
  rating: number;
  title: string;
  message: string;
  gallery: string[];
}
